export default __webpack_public_path__ + "static/media/postarrow.1570df73.svg";